import BuysOrderSheetListContainer from '../../containers/buys_order_sheet/BuysOrderSheetListContainer';

const BuysOrderSheetPage = () => {
  return <BuysOrderSheetListContainer />;
};

export default BuysOrderSheetPage;
